'use client';

import React from 'react';

import { CloseCurrentButton } from '~/app/common/components';

import { AppLayout } from './AppLayout';

type Props = React.PropsWithChildren & {
  path?: string;
  title?: string;
  /**
   * 닫기 버튼 클릭 시 호출되어 실제 닫기 동작 여부를 결정한다.
   * true 반환 시 닫기 진행, false 반환 시 취소.
   */
  onBeforeClose?: () => Promise<boolean> | boolean;
};

export function ModalCloseLayout({
  title,
  path,
  onBeforeClose,
  children,
}: Props) {
  return (
    <AppLayout
      title={title}
      onLeftClick={null}
      right={<CloseCurrentButton path={path} onBeforeClose={onBeforeClose} />}
    >
      {children}
    </AppLayout>
  );
}
